<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{ $t("soporte.titulo") }}</h1>
      <div class="toolbar">
        <button type="button" @click.prevent="crearTicket()" class="btn btn-link">
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid"
      class="dx-card wide-card grid-soporte">
      <DxColumnFixing :enabled="true" />
      <DxColumn data-field="CodigoSecuencial" :caption="$t('soporte.grid.id')" format="00000"></DxColumn>
      <DxColumn data-field="Responsable" :caption="$t('soporte.grid.responsable')"></DxColumn>
      <DxColumn data-field="Tipo" :caption="$t('soporte.grid.tipo')" cell-template="tipoTemplate">
        <DxLookup v-bind="getLookup('ticket', 'tipo')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Subtipo" :caption="$t('soporte.grid.subtipo')" cell-template="subtipoTemplate">
        <DxLookup v-bind="getLookup('ticket', 'subtipo')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Asunto" :caption="$t('soporte.grid.asunto')" cell-template="asuntoTemplate" width="360px">
      </DxColumn>
      <DxColumn data-field="Estado" :caption="$t('soporte.grid.estado')" cell-template="estadoTemplate">
        <DxLookup v-bind="getLookup('ticket', 'estado')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="FechaCreacion" :caption="$t('soporte.grid.fecha_de_creacion')" data-type="datetime"
        format="dd/MM/yyyy HH:mm:ss"></DxColumn>
      <DxColumn data-field="FechaUltimoMensaje" :caption="$t('soporte.grid.fecha_ult_mensaje')" data-type="datetime"
        format="dd/MM/yyyy HH:mm:ss"></DxColumn>

      <DxColumn type="buttons" :caption="$t('soporte.grid.acciones')" :fixed="true" width="100px"
        fixed-position="right" :buttons="[
          {
            cssClass: 'btn btn-link text-decoration-none btn-sm',
            icon: 'fa-solid fa-magnifying-glass text-success',
            hint: $t('soporte.grid.ver_detalle'),
            onClick: (e: any) => verDetalle(e.row.data.Id)
          }
        ]"/>

      <template #estadoTemplate="{ data }">
        <div :class="[
          `d-inline-block rounded py-1 px-2`,
          `estado ${data.value.replace(' ', '')}`,
        ]">
          {{ $t(`ticket.estado.${data.value}`) }}
        </div>
      </template>
      <template #tipoTemplate="{ data }">
        <div class="d-flex">
          {{ $t(`ticket.tipo.${data.value}`) }}
        </div>
      </template>
      <template #subtipoTemplate="{ data }">
        <div v-if="data.value" class="d-flex">
          {{ $t(`ticket.subtipo.${data.value}`) }}
        </div>
      </template>
      <template #asuntoTemplate="{ data }">
        <div class="asunto-container">
          {{ data.value }}
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import {
  DxColumn,
  DxDataGrid,
  DxColumnFixing,
  DxLookup
} from "devextreme-vue/data-grid";
import {
  getDefaultGridProperties,
} from "@helpers/grid-helper";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from "vue";
import { getLookup } from "@helpers/grid-helper";
import { useIntl } from "@services/i18n";
import { useRouter } from '@/.shared/services/routing-services';
import { useModalService } from "@services/modal-service";
import { messageBoxResult } from "@/.shared/components/dialogs/message-box";
import TicketForm from "@/.shared/components/soporte/TicketForm.vue";
import { CreateTicket } from "@/.shared/components/soporte/models/CreateTicket";
import { useEmpresaAgentesPortalRestringido } from "@/composables/empresaAgentesPortalRestringido";

const intl = useIntl();
const api = useApi();
const router = useRouter();
const { accesoRestringido } = useEmpresaAgentesPortalRestringido();
const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();
const modal = useModalService();

onMounted(async () => {
  gridSource.value = api.apiStore({
    key: "Id",
    load: await api.toStandardApiFunction("getTicketsForGrid", { showLoading: false })
  });
});

async function crearTicket() {
  let title = `${intl.i18n.t("ticket.creacion.titulo")}`;
  await modal.showModal(
    TicketForm,
    { model: new CreateTicket(), restringirSoloTipoOtros: accesoRestringido.value },
    { title: title, width: 800, height: 700 }
  ).then((value) => {
    if (value == messageBoxResult.ok)
      grid.value?.instance?.refresh();
  });
}

const verDetalle = async (id: string) => {
  await router.push(intl.i18Route({ name: "ticket", params: { "id": id } }));
}

</script>

<style lang="scss" scoped>

.asunto-container {
  white-space: normal;
}
</style>
